export default __webpack_public_path__ + "assets/images/rules-59db5acd61c2078bbcaef082eeee3579.svg";